export type BookingTypeSummary = {
  id: string;
  slug: string;
  name: string;
  description: string;
  durationMin: number;
  priceCents: number | null;
  depositRequired: boolean;
  color: string;
  timezone: string;
  sortOrder: number;
};

export type SlotApi = {
  startUtc: string;
  endUtc: string;
};

export type AvailabilityResponse = {
  bookingType: { id: string; slug: string; name: string; durationMin: number; timezone: string };
  slots: Record<string, SlotApi[]>;
};

export type CreateBookingResponse =
  | {
      bookingNumber: string;
      manageUrl: string;
      manageToken: string;
      requiresPayment: false;
    }
  | {
      bookingNumber: string;
      manageUrl: string;
      manageToken: string;
      stripeCheckoutUrl: string;
      requiresPayment: true;
    };

export function formatPrice(priceCents: number | null): string {
  if (priceCents === null) return 'Free';
  return `$${(priceCents / 100).toFixed(0)}`;
}

export function formatDuration(min: number): string {
  if (min < 60) return `${min} min`;
  if (min === 60) return '1 hr';
  if (min === 90) return '1 hr 30 min';
  return `${Math.floor(min / 60)} hr ${min % 60} min`;
}
